import React from 'react';
import { styled } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Colors } from 'library';
import { RAvatar } from './RAvatar';

interface RPersonChipProps {
    firstName: string;
    lastName: string;
    onRemove?: () => void;
}

export function RPersonChip({ firstName, lastName, onRemove }: RPersonChipProps) {
    const initials = `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase();

    return (
        <Chip>
            <RAvatar initials={initials} size={28} />
            <Name>{firstName} {lastName}</Name>
            {onRemove && (
                <RemoveButton onClick={onRemove}>
                    <Close sx={{ fontSize: 14 }} />
                </RemoveButton>
            )}
        </Chip>
    );
}

const Chip = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 12px',
    borderRadius: 20,
    border: `1px solid ${Colors.lightGrey}`,
    backgroundColor: Colors.faintGrey,
    fontSize: 14,
    color: Colors.darkNavy,
});

const Name = styled('span')({
    fontSize: 14,
    color: Colors.darkNavy,
});

const RemoveButton = styled('button')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 2,
    border: 'none',
    backgroundColor: 'transparent',
    color: Colors.mediumGrey,
    cursor: 'pointer',
    borderRadius: '50%',
    '&:hover': {
        color: Colors.darkNavy,
        backgroundColor: Colors.fill,
    },
});
